"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classnames = _interopRequireDefault(require("classnames"));

var getButtonClassList = function getButtonClassList(props) {
  return (0, _classnames.default)({
    btn: true,
    'btn-primary': props.primary,
    'btn--insided-brand': props.insided,
    'btn--purple': props.insidedPurple,
    'btn--insided-secondary-brand': props.insidedSecondary,
    'btn-cancel-link': props.cancel && props.link,
    'btn-default': props.default,
    'btn-success': props.success,
    'btn-danger': props.danger,
    'btn-warning': props.warning,
    'btn-secondary': props.secondary,
    'btn--toggle': props.toggle,
    'is-active': props.toggleActive,
    'is-loading': props.loading,
    'btn--S': props.small,
    'btn--M': props.medium,
    'btn--cta': props.cta,
    'btn-cancel': props.cancel && !props.link
  }, props.qaClasses, props.class, props.className);
};
/**
 * @deprecated
 * Use Button from `@insided/control/uikit/Button`
 */


var Button = function Button(props) {
  var _props$type, _props$title;

  var trackProps = props['data-element-name'] ? {
    'data-element-name': props['data-element-name'],
    'data-track-type': props['data-track-type']
  } : {};
  return (0, _preact.h)("button", (0, _extends2.default)({
    type: (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'button',
    onClick: props.onClick,
    style: props.style,
    disabled: props.disabled,
    className: getButtonClassList(props)
  }, trackProps), (0, _preact.h)("div", {
    className: "btn--loader loader"
  }), (0, _preact.h)("span", {
    className: "btn__hide-when-loading"
  }, (_props$title = props.title) !== null && _props$title !== void 0 ? _props$title : props.children));
};

var _default = Button;
exports.default = _default;